import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMycorrMedium = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M24 16V32L40 40V8L24 16ZM24 16L8 8V32",
		stroke: "currentColor",
		strokeWidth: 4,
		strokeLinejoin: "bevel"
	})
});
export default SvgMycorrMedium;
